// @core/api/endpoints/audittrail/search_audit_records.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditRecordsResponse,
  SearchAuditRecordsRequest,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Search audit records
 * Full-text search within the audit trail. Searches across event types, resource URNs, justifications, and metadata.
 */
export async function SearchAuditRecords(
  data: SearchAuditRecordsRequest,
  options?: RequestOptions
): Promise<ListAuditRecordsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/records/search`;
  const requestOptions = options;
  return client.post<ListAuditRecordsResponse>(requestPath, data, requestOptions);
}
